import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type ConnectionDataInterface, AgentsApiState } from '~/src/redux/agents-api/agents-api.types';

const initialState = new AgentsApiState();

const agentsApiSlice = createSlice({
    name: 'agentsApi',
    initialState,
    reducers: {
        setConnectionListAction: (state, action: PayloadAction<Array<ConnectionDataInterface>>) => {
            return {
                ...state,
                connectionList: action.payload,
            };
        },
        setConnectionAction: (state, action: PayloadAction<ConnectionDataInterface>) => {
            return {
                ...state,
                connectionList: [...state.connectionList, action.payload],
            };
        },
    },
});

export const { setConnectionListAction, setConnectionAction } = agentsApiSlice.actions;
export const agentsApiReducer = agentsApiSlice.reducer;
